import { Info } from "lucide-react";
import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/shared/components/ui/hover-card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";

export type RentingFeesInfoCellRow = {
  durationMonths: number;
  monthly: number;
};

export function RentingFeesInfoCell({
  rows,
}: {
  rows: RentingFeesInfoCellRow[];
}) {
  const sortedRows = [...rows]
    .filter((row) => row.durationMonths > 0)
    .sort((left, right) => left.durationMonths - right.durationMonths);

  if (sortedRows.length === 0) {
    return <span className="text-muted-foreground">-</span>;
  }

  return (
    <HoverCard openDelay={100}>
      <HoverCardTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-8 w-8"
          aria-label={t("Mietpreise anzeigen")}
        >
          <Info className="h-4 w-4" />
        </Button>
      </HoverCardTrigger>
      <HoverCardContent align="start" className="w-72 p-3">
        <div className="mb-2 text-sm font-medium">{t("Mietpreise")}</div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t("Laufzeit")}</TableHead>
              <TableHead className="text-right">{t("Monatlich")}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sortedRows.map((row) => (
              <TableRow key={row.durationMonths}>
                <TableCell>
                  {row.durationMonths} {t("Mon.")}
                </TableCell>
                <TableCell className="text-right">
                  {row.monthly.toFixed(2)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </HoverCardContent>
    </HoverCard>
  );
}
